import { Component, OnInit, ElementRef } from '@angular/core';

import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ControlTypeName } from '../../types/control-type-name';
import { ControlValidateMoment } from '../../types/validator.types';
import { ValueControlViewModel } from '../../types/control.types';
import { PropertyDateFormatType, PropertyTimeFormatType } from '../../types/property.types';
import { ControlModelPropertyEnum } from '../../types/control-model-property';

@Component({
  selector: 'df-datetime',
  templateUrl: './datetime.component.html',
  styleUrls: ['./datetime.component.css']
})
export class DatetimeComponent extends AbstractValueControlBase<ValueControlViewModel> implements OnInit {
  changeDetected = false;
  type = ControlTypeName.dateTime;
  showTime: boolean = false;
  showSeconds: boolean = false;
  timeOnly: boolean = false;
  dateFormat: string = 'yy-mm-dd';
  monthNavigator: boolean = true;
  yearNavigator: boolean = true;
  yearRange = '1900:2999';
  zh: any;
  view = 'date';

  set value(val: Date) {
    this._value = val;
  }

  get value(): Date {
    return this._value;
  }

  private modelDateFormat: string;
  private modelTimeFormat: string;
  private showFormat: string; // æ¾ç¤ºæ¥ææ ¼å¼
  private valueFormat: string; // å¼æ¥ææ ¼å¼
  private _value: Date;

  constructor(protected element: ElementRef) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.propertyValueChanged$.subscribe((s) => {
      if (s.name === ControlModelPropertyEnum.Value) {
        this.setModelValue(s.value);
      }
    });

    this.customEventNames = ['change'];
    this.zh = {
      firstDayOfWeek: 0,
      dayNames: ['ææå¤©', 'ææä¸', 'ææäº', 'ææä¸', 'ææå', 'ææäº', 'ææå­'],
      dayNamesShort: ['å¤©', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'],
      dayNamesMin: ['å¤©', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'],
      monthNames: ['ä¸æ', 'äºæ', 'ä¸æ', 'åæ', 'äºæ', 'å­æ', 'ä¸æ', 'å«æ', 'ä¹æ', 'åæ', 'åä¸æ', 'åäºæ'],
      monthNamesShort: ['1æ', '2æ', '3æ', '4æ', '5æ', '6æ', '7æ', '8æ', '9æ', '10æ', '11æ', '12æ'],
      today: 'ä»å¤©',
      clear: 'æ¸é¤',
      dateFormat: this.dateFormat
    };
    this.modelDateFormat = this.model[`dateFormat`];
    this.modelTimeFormat = this.model[`timeFormat`];
    this.changeShow();
    this.showFormat = this.getFormate();
    this.valueFormat = this.getValueFormate();
  }

  setModelValue(val: any) {
    this.value = this.getDate(val);
    this.model.value = this.getDate(val);
  }

  getModelValue(): string {
    return this.getValueFormatDate(this.getDate(this._value));
  }

  getShowContent() {
    return this.getShowFormatDate(this.getDate(this._value));
  }

  onSelect(result: Date): void {
    this.change(result);
    this.setModelValue(result);
    this.validateAtMoment(ControlValidateMoment.Input);
    this.validateAtMoment(ControlValidateMoment.Change);
    this.broadControlValueChange();
  }

  onBlur(event: any) {
    this.change(event);
    if (event && event.target) {
      this.setModelValue(event.target.value);
    } else {
      this.setModelValue(undefined);
    }
    this.validateAtMoment(ControlValidateMoment.Blur);
    this.broadControlValueChange();
  }

  // bindEvents(): void {
  //   this.bindEventsToEl(this.valueElement);
  // }

  changeShow() {
    if (!this.modelDateFormat && !this.modelTimeFormat) {
      // é½ä¸é æ¾ç¤ºå¹´ææ¥æ¶åç§
      this.dateFormat = 'yy-mm-dd';
      this.showTime = true;
      this.showSeconds = true;
      return;
    }
    if (this.modelDateFormat) {
      // æ¾ç¤ºdate å¹´ææ¥
      this.getDateFormat();
      if (!this.modelTimeFormat) {
        // ä¸æ¾ç¤ºæ¶åç§
        this.showTime = false;
        this.showSeconds = false;
      } else {
        // æ¾ç¤ºæ¶å(ç§)
        this.showTime = true;
        this.showSeconds = this.modelTimeFormat === PropertyTimeFormatType.hourMinuteSecond;
      }
      return;
    }
    // åªæ¾ç¤ºæ¶å(ç§)
    this.timeOnly = true;
    this.showTime = true;
    this.showSeconds = this.modelTimeFormat === PropertyTimeFormatType.hourMinuteSecond;
    return;
  }

  private change(event: any) {
    this.callEvent('change', event);
  }

  private getDate(val: any): Date {
    if (!val) {
      return undefined;
    }

    if (val instanceof Date) {
      return val;
    }

    // TODO åºè¯¥è½¬æ¢ä¸ºUTCæ¶é´, éè¦èèåæ°æ®å¼å®¹,çè®ºä¸åºè¯¥å­çæ¶åå­utc0æ¶åºæ ¼å¼çæ¥æï¼è¿æ ·è¿éå°±ä¸éè¦åé¢å¤å¤çäºï¼ä¹å¯ä»¥å¼å®¹åç§ç±»åæ°æ®åº
    // mysqlä¸­è¿åçæ¯å¸¦Tæ ¼å¼ç ä¾å¦â2021-06-08T01:34:21â å¦æè¿ä¸ªä½ä¸ºutc 0æ¶åºæ¶é´ï¼åå­æ°æ®å°ä¸è½ä¿æå¼å®¹
    // å¦ææç§åå­æ°æ®æ¯ä¸å«åºæ¶é´ï¼å½éåçæ¶åï¼æ æ³ç¡®å®æ¯é£ä¸ªåºçæ¶é´ï¼ï¼éè¦ä»£ç åå¼å®¹ï¼æ¶åºä¸­åå»ä¸å«åºçåç§»(ææ¶æ²¡æå¤ç)
    // å¦æè¿åçæ¯å¸¦zçæ ¼å¼çï¼å­ç¬¦ä¸²å­å¨ï¼ ç´æ¥ä½¿ç¨åæ ¼å¼å³å¯
    // safariä¸­å¼å®¹â2021-06-08T01:34:21âåâ2021-06-08T01:34:21Zâæ ¼å¼
    let dateStr = val.replace(/-/g, '/');
    dateStr = dateStr.replace('T', ' ');
    const date = new Date(dateStr);
    if (this.isValidDate(date)) {
      return date;
    }
    return undefined;
  }

  private formatDate(format: string, date: Date) {
    if (!date) {
      return null;
    }
    const o = {
      'M+': date.getMonth() + 1, // æä»½
      'd+': date.getDate(), // æ¥
      'h+': date.getHours(), // å°æ¶
      'm+': date.getMinutes(), // å
      's+': date.getSeconds(), // ç§
      'q+': Math.floor((date.getMonth() + 3) / 3), // å­£åº¦
      S: date.getMilliseconds() // æ¯«ç§
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (const k in o)
      if (new RegExp('(' + k + ')').test(format))
        format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return format;
  }

  /**
   * è·åæ¾ç¤ºçæ ¼å¼åçå¼
   *
   */
  private getShowFormatDate(date: Date) {
    return this.formatDate(this.showFormat, date);
  }

  /**
   * è·åå­å¨çæ ¼å¼å¼
   */
  private getValueFormatDate(date: Date) {
    return this.formatDate(this.valueFormat, date);
  }

  private getFormate() {
    let format = 'yyyy-MM-dd';
    if (this.dateFormat === PropertyDateFormatType.yearMonth) {
      format = 'yyyy-MM';
    }
    if (this.dateFormat === PropertyDateFormatType.yearMonthDay) {
      format = 'yyyy-MM-dd';
    }
    if (this.showTime) {
      format += ' hh:mm';
      if (this.showSeconds) {
        format += ':ss';
      }
    }
    return format;
  }

  private getValueFormate() {
    let format = 'yyyy/MM/$dd $hh:$mm:$ss';
    switch (this.dateFormat) {
      case PropertyDateFormatType.yearMonth:
        format = format.replace('$dd', '01');
        break;
      case PropertyDateFormatType.yearMonthDay:
        format = format.replace('$dd', 'dd');
        break;
      default:
        format = format.replace('$dd', 'dd');
    }

    if (this.showTime) {
      format = format.replace('$hh', 'hh').replace('$mm', 'mm');
      if (this.showSeconds) {
        format = format.replace('$ss', 'ss');
      } else {
        format = format.replace('$ss', '00');
      }
    } else {
      format = format.replace('$hh', '00').replace('$mm', '00').replace('$ss', '00');
    }
    return format;
  }

  private getTimeZoneOffset(date: Date) {
    let minute = date.getTimezoneOffset();
    const prefix = minute > 0 ? '-' : '+';
    minute = Math.abs(minute);
    const zoneHour = parseInt((minute / 60).toString(), 0)
      .toString()
      .padStart(2, '0');
    const zoneMinute = parseInt((minute % 60).toString(), 0)
      .toString()
      .padStart(2, '0');
    return prefix + zoneHour + zoneMinute;
  }

  private getDateFormat() {
    if (this.modelDateFormat === PropertyDateFormatType.yearMonth) {
      this.dateFormat = 'yy-mm';
      this.view = 'month';
      return;
    }

    this.dateFormat = 'yy-mm-dd';
    this.view = 'date';
  }

  private isValidDate(date: Date): boolean {
    return date instanceof Date && !isNaN(date.getTime());
  }
}
